/**
 * Deli smoked fish data
 * Represents smoked fish available by weight at the deli counter
 */

const deliSmokedFish = [
  {
    id: 1,
    name: "Nova Lox*",
    category: "fish"
  },
  {
    id: 2,
    name: "Hand Cut Lox*",
    category: "fish"
  },
  {
    id: 3,
    name: "Smoked Sable",
    category: "fish"
  },
  {
    id: 4,
    name: "Smoked Whitefish",
    category: "fish"
  },
  {
    id: 5,
    name: "Kippered Salmon",
    category: "fish"
  }
];

module.exports = deliSmokedFish;